import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ModalUI from '../../../../../shared/components/Modal';
import Modal from '@material-ui/core/Modal';
import FormAddAlergie from "../../../../Patient/DisplayPatientInformation/components/alergies/FormAddAlergie";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class Other extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadedListAlergies: false,
            alergiesList: [],
            patientAlergies: [],
            openModalFormAddAlergie: false,
            alergieToForm: null,
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            loadedPatientAlergies: false,
            nameAlergieToPush: ''
        }
    }
    //handlerChangeColorAlergies
    componentDidMount() {
        this.getListAlergies();
        this.getPatientAlergies();
    }

    getListAlergies = async () => {
        this.setState({ loadedListAlergies: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias-listado/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando el listado de alergias");
            }
        }).then((data) => {
            if (data.length > 0) {
                console.log("Alergias", data);
                this.setState({ loadedListAlergies: false, alergiesList: data });
            }
            else {
                this.setState({ loadedListAlergies: false, alergiesList: [] });
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loadedListAlergies: false });
        });
    }

    saveAlergie = async (alergieAdd, fromTextField) => {
        let data = {
            nombre: alergieAdd.nombre,
            alergia_vigente: false,
            es_removible: false,
            es_uso: false,
            severidad: 0,
            reaccion: '',
            fecha: null,
            etapa: 0,
            comentario: '',
            id_historia: this.props.id_historia
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error guardando la alergia");
            }
        }).then((data) => {
            console.log("DATARESPONSE",);
            if (!fromTextField) {
                let listAlergies = this.state.alergiesList;
                let newAlergiesList = listAlergies.filter(alergie => alergie.nombre !== alergieAdd.nombre);
                this.setState({ alergiesList: newAlergiesList });
                if (!!this.state.patientAlergies.length) {
                    this.props.handlerChangeColorAlergies('#F71C06');
                } else {
                    this.props.handlerChangeColorAlergies('#55e5bb');
                }
                /* this.setState({
                    openAlert: true,
                    modalAlert: { message: "Guardado con exito", color: 'success', title: "Exitoso!" },
                    alergiesList: newAlergiesList
                }); */
                //getPatientAlergies();
            } else {
                let currentPatientAlergies = this.state.patientAlergies
                let alergieToPush = !!data ? !!data.alergia ? data.alergia : { nombre: alergieAdd.nombre, categoria: null, codigo: null, id_alergia_listado: null } : { nombre: alergieAdd.nombre, categoria: null, codigo: null, id_alergia_listado: null };
                currentPatientAlergies.push(alergieToPush);
                this.setState({ patientAlergies: currentPatientAlergies, nameAlergieToPush: '' })
                if (!!this.state.patientAlergies.length) {
                    this.props.handlerChangeColorAlergies('#F71C06');
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    getPatientAlergies = async () => {
        this.setState({ loadedPatientAlergies: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/listar?id_historia=' + this.props.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando las alergias del paciente");
            }
        }).then((data) => {
            let listAlergies = this.state.alergiesList;
            if (data.length > 0) {
                this.props.handlerChangeColorAlergies('#F71C06');
                let newAlergiesList = [];
                listAlergies.forEach(aler => {
                    let evaluate = data.some(alg => alg.nombre === aler.nombre)
                    if (!evaluate) {
                        newAlergiesList.push(aler)
                    }
                })
                this.setState({ patientAlergies: data, alergiesList: newAlergiesList })
            }
            this.setState({ loadedPatientAlergies: false });
        }).catch(err => {
            console.log(err);
            this.setState({ loadedPatientAlergies: false });
        });
    }

    deleteAlergie = (id_alergia) => {
        let data = {
            id_alergia: id_alergia
        }
        fetch(process.env.REACT_APP_PUBLIC_URL + 'alergias/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)

        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.text();
            }
            else {
                throw new Error("Error eliminando la alergia del paciente");
            }
        }).then((data) => {
            //getPatientAlergies();
            this.dropAlergieFormTexfield(this.state.alergieToForm);
        }).catch(err => {
            console.log(err);
        });
    }

    dropAlergieFormTexfield = (alergieToForm) => {
        //FieldText
        let alergiesSelectedTextField = this.state.patientAlergies;
        let newAlergies = alergiesSelectedTextField.filter((alergie) => alergie.nombre !== alergieToForm.nombre);
        this.setState({ patientAlergies: newAlergies })
        if (!!newAlergies.length) {
            this.props.handlerChangeColorAlergies('#F71C06');
        } else {
            this.props.handlerChangeColorAlergies('#55e5bb');
        }

        //addAlergieslist
        let listAlergies = this.state.alergiesList;
        let search = listAlergies.find(aler => aler.nombre === alergieToForm.nombre)
        if (!search) {
            listAlergies.unshift(alergieToForm);
            this.setState({ alergiesList: listAlergies })
        }
    }

    handlerAddAlergies = (alergie, reason, detail) => {
        this.setState({ patientAlergies: alergie });
        if (reason === 'select-option') {
            //this.setState({ openModalFormAddAlergie: true, alergieToForm: detail.option });
            this.saveAlergie(detail.option, false);
        }


        if (reason === 'remove-option') {
            let alergieToErase = this.state.patientAlergies.find((aler)=> aler.nombre === detail.option.name);
            this.setState({
                openAlert: true,
                modalAlert: { message: '¿Esta seguro que desea eliminar la alergia?', color: 'warning', title: 'Eliiminar!' },
                alergieToForm: !!alergieToErase ? alergieToErase : detail.option
            });
        }
    }

    onOkModal = () => {
        switch (this.state.modalAlert.color) {
            case "sucess":
                this.setState({ openAlert: !this.state.openAlert });
                break;
            case "warning":
                this.deleteAlergie(this.state.alergieToForm.id_alergia);
                this.setState({ openAlert: !this.state.openAlert });
                break;
            default:
                break;
        }
    }

    handlerToCloseFormAddModal = (actionToClose) => {
        this.setState({ openModalFormAddAlergie: actionToClose })
    }

    handlerNameAlergieToPush = (value) => {
        this.setState({ nameAlergieToPush: value })
    }

    handlerAddAlergieFromTextField = (alergieTextToAdd) => {
        //alergieAdd.nombre,
        let alegieToAdd = { nombre: alergieTextToAdd }
        this.saveAlergie(alegieToAdd, true);
    }


    render() {
        return (
            <Fragment>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Alergías</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'alergias');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-alergias"
                                        name="radio-others-alergias"
                                        value={this.props.sectionAilment.others.alergias.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background flex-spac-ar-elem">
                                <div style={{ width: '95%', marginRight: '1.25em', marginTop: '0.8em' }}>
                                    <FormControl
                                        style={{ width: '100%' }}
                                    /* error={errors.hasOwnProperty("patientAlergies") ? errors.patientAlergies !== "" : false} */
                                    >
                                        <Autocomplete
                                            multiple
                                            id="tags-standard"
                                            style={{ width: '100%' }}
                                            options={this.state.alergiesList}
                                            value={this.state.patientAlergies}
                                            getOptionLabel={(option) => option.nombre}
                                            disabled={this.props.sectionAilment.others.alergias.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                            onChange={(event, value, reason, detail) => {
                                                console.log("evento", event, "valor", value, "reason", reason, "detail", detail);
                                                this.handlerAddAlergies(value, reason, detail);
                                            }}
                                            renderInput={(params) => {
                                                console.log("WhatParams", params)
                                                return (<TextField
                                                    {...params}
                                                    variant="standard"
                                                    label=""
                                                    placeholder="Alergia"
                                                    className='text-field-autocomplete'
                                                />)
                                            }}
                                        />
                                    </FormControl>
                                </div>
                                <div style={{ width: '95%', marginLeft: '0.25em' }}>
                                    <TextField
                                        label="Otro?"
                                        disabled={this.props.sectionAilment.others.alergias.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                        value={/* this.props.sectionAilment.others.alergias.comentario */this.state.nameAlergieToPush}
                                        onChange={(e) => {
                                            // this.props.handlerOthersBackgroundText(e.target.value, 'alergias');
                                            this.handlerNameAlergieToPush(e.target.value)
                                        }}
                                        style={{ minWidth: '100%', maxWidth: '100%' }}
                                        className="medical-material-form__field"
                                        InputLabelProps={{
                                            //style: { color: '#646777' }
                                        }}
                                    />
                                </div>
                                <div>
                                    <Tooltip title="Agregar"
                                        disabled={this.props.stateClinicHistory}
                                    >
                                        <IconButton
                                            color="primary"
                                            disabled={!this.state.nameAlergieToPush}
                                            onClick={() => {
                                                this.handlerAddAlergieFromTextField(this.state.nameAlergieToPush)
                                            }}>
                                            <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Traumaticos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'traumatico');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-traumatico"
                                        name="radio-others-traumatico"
                                        value={this.props.sectionAilment.others.traumatico.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.traumatico.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.traumatico.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'traumatico');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Hospitalarios</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'hospitalario');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-hospitalario"
                                        name="radio-others-hospitalario"
                                        value={this.props.sectionAilment.others.hospitalario.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.hospitalario.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.hospitalario.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'hospitalario');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black' }} disabled={true}>Psiquiatricos</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'psiquiatricos');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-psiquiatricos"
                                        name="radio-others-psiquiatricos"
                                        value={this.props.sectionAilment.others.psiquiatricos.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.psiquiatricos.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.psiquiatricos.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'psiquiatricos');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background">
                                <FormControl component="fieldset" >
                                    <FormLabel style={{ color: 'black', position: 'absolute', width: '300px' }} disabled={true}>{'Enfermedades de Transmisión Sexual'}</FormLabel>
                                    <FormLabel style={{ color: 'black' }} disabled={true}>&nbsp;</FormLabel>
                                    <RadioGroup
                                        onChange={(e) => {
                                            this.props.handlerOthersBackgroundRadio(e.target.value, 'enfermades_t_sexual');
                                        }}
                                        row aria-label="position"
                                        id="radio-others-enfermades_t_sexual"
                                        name="radio-others-enfermades_t_sexual"
                                        value={this.props.sectionAilment.others.enfermades_t_sexual.value}>
                                        <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                        <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.others.enfermades_t_sexual.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.others.enfermades_t_sexual.comentario}
                                    onChange={(e) => {
                                        this.props.handlerOthersBackgroundText(e.target.value, 'enfermades_t_sexual');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={6} xs={12}>
                        <div className="element-question-background">
                            <div className="question-background"></div>
                        </div>
                        <div className="answer-background">
                        </div>
                    </Col>
                </Row>
                <div className="form">
                    <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                    <div className="form__form-group-field">
                        <textarea
                            id="textarea-observation"
                            value={this.props.sectionAilment.others.observacion}
                            disabled={this.props.stateClinicHistory}
                            name="textarea-surgical"
                            onChange={(e) => {
                                this.props.handlerOthersBackgroundObservation(e.target.value, 'observacion');
                            }}
                        >
                        </textarea>
                    </div>
                </div>
                {this.state.openModalFormAddAlergie == true ?
                    <Fragment>
                        <Modal
                            open={this.state.openModalFormAddAlergie}
                            /* onClose={() => {
                                setOpenModalFormAddAlergie(false);
                            }} */
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '80%', margin: 10 }}>
                                <FormAddAlergie id_historia={this.props.id_historia} alergieToForm={this.state.alergieToForm} setOpenModalFormAddAlergie={this.handlerToCloseFormAddModal} dropAlergieFormTexfield={this.dropAlergieFormTexfield} />
                            </div>
                        </Modal>
                    </Fragment>
                    : null
                }
                {
                    this.state.openAlert ?
                        <ModalUI
                            color={this.state.modalAlert.color
                            }
                            title={this.state.modalAlert.title}
                            message={this.state.modalAlert.message}
                            modal={this.state.openAlert}
                            toggle={() => { this.setState({ openAlert: !this.state.openAlert }, () => this.getPatientAlergies()) }}
                            onOk={() => this.onOkModal()}
                        /> : null}
            </Fragment>

        );
    }
}

export default Other;
